import { LegsSystem } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const deleteLegs = ({ coreApi }: BehaviorParameters) => {
  const system = coreApi.getSystem<LegsSystem>('LegsSystem');
  if (!system) {
    return;
  }

  system.updateLegsWithHistory(system?.defaultLegProductRef);
};

export default deleteLegs;
